import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const nurseryUnlicensedDemerit: BlogMetaData = {
  title: '認可外保育園のデメリットとは？8つの注意点とメリットも解説',
  description:
    '認可外保育園とは、認可基準を満たしていない、または申請していない保育施設のこと。認可保育園との違いから、保育士配置や施設基準のばらつきなど気になるデメリット8つ、見学で見極めるポイント、認可外ならではのメリットまでわかりやすく解説します。',
  thumbnailUrl: '/img/blog-nursery-unlicensed-demerit.webp',
  filePath: buildBlogFilePath('nursery-unlicensed-demerit'),
  category: BLOG_CATEGORY.NURSERY,
};
